// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2YOYw","label":"LabeledBox_label__2jR0v"};